import { render, staticRenderFns } from "./TransliteratedAlphabet.vue?vue&type=template&id=31953f8f&"
import script from "./TransliteratedAlphabet.vue?vue&type=script&lang=js&"
export * from "./TransliteratedAlphabet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/dev/www/word-trainer-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {VContainer})
